import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { OrdenTrabajoNoc } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { cellNotFilter } from "@/shared/utils";

export const useTableColumnsWorkOrder = () => {

  const columnsWorkOrder = useMemo<MRT_ColumnDef<OrdenTrabajoNoc>[]>(
    () => [
      {
        accessorKey: 'orderName',
        header: 'NOMBRE DE LA ORDEN',
      },
      {
        accessorKey: 'orderCode',
        header: 'CODIGO DE LA ORDEN',
      },
      {
        accessorKey: 'workDate',
        header: 'FECHA DE TRABAJO',
      },
      {
        accessorKey: 'fleetName',
        header: 'FLOTA ASIGNADA',
      },
      {
        ...cellNotFilter,
        accessorKey: 'activitiesOrder',
        header: 'CANTIDAD DE ACTIVIDADES',
        Cell: ({ row }) => (
          row.original.activitiesOrder.length
        ),
      },
      {
        accessorKey: 'registrationDate',
        header: 'FECHA DE CREACION',
      },
      {
        accessorKey: 'userRegister',
        header: 'USUARIO DE CREACION',
      },
    ],
    [],
  );

  return {
    columnsWorkOrder,
  }
}